import { Redirect, Route, Switch } from 'react-router-dom';

import { NewFlowTemplatePickerPageWithProvider } from './Agents/Details/TemplatePicker/PageWithProvider';
import { FlowTemplatePreviewPageWithProvider } from './Agents/Details/TemplatePicker/Preview/PageWithProvider';

export function TrialAppRoutes() {
  return (
    <Switch>
      <Route
        exact
        path="/agents/flows/create/:templateId"
        component={FlowTemplatePreviewPageWithProvider}
      />
      <Route path="/agents/flows/create" component={NewFlowTemplatePickerPageWithProvider} />
      <Redirect to="/agents/flows/create" />
    </Switch>
  );
}
